<template>
    <div>
        <div class="tw-flex tw-flex-wrap tw-gap-2">
            <div
                v-for="(photo, index) in value"
                :key="index"
                class="slip-thumb"
            >
                <img
                    v-if="isImage(photo)"
                    :src="photo"
                    class="slip-thumb-img"
                    @click="$emit('preview', index)"
                />
                <div
                    v-else
                    class="slip-thumb-file"
                    @click="$emit('preview', index)"
                >
                    <i class="fas fa-file-alt tw-text-green-500 tw-text-2xl"></i>
                    <span class="tw-text-xs tw-text-gray-600 tw-mt-1 tw-truncate tw-block" style="max-width: 72px;">
                        {{ fileName(photo) }}
                    </span>
                </div>
                <button
                    type="button"
                    class="slip-thumb-remove"
                    :title="$t('remove')"
                    @click.prevent="$emit('remove', index)"
                >
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div
                class="slip-add"
                :class="{ 'is-loading': loading }"
                @click="!loading && $refs.fileInput.click()"
                @dragover.prevent="isDragging = true"
                @dragleave.prevent="isDragging = false"
                @drop.prevent="onDrop"
            >
                <div v-if="loading" class="tw-flex tw-flex-col tw-items-center">
                    <i class="fas fa-circle-notch fa-spin tw-text-blue-400 tw-text-xl"></i>
                    <span class="tw-text-xs tw-text-gray-500 tw-mt-1">{{ $t('uploading') || 'Uploading…' }}</span>
                </div>
                <div v-else class="tw-flex tw-flex-col tw-items-center">
                    <i class="fas fa-cloud-upload-alt tw-text-blue-400 tw-text-xl"></i>
                    <span class="tw-text-xs tw-text-gray-600 tw-mt-1 tw-font-medium">
                        {{ value.length ? ($t('addMore') || 'Add more') : ($t('clickOrDragToUpload') || 'Click or drag') }}
                    </span>
                </div>
                <input
                    ref="fileInput"
                    type="file"
                    accept="image/*,application/pdf"
                    class="tw-hidden"
                    multiple
                    @change="onFileChange"
                />
            </div>
        </div>

        <div v-if="error" class="invalid-feedback d-block tw-mt-1">{{ error }}</div>
    </div>
</template>

<script>
export default {
    name: "BankSlipPhotosUpload",
    props: {
        value:   { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
        error:   { type: String, default: null }
    },
    data() {
        return { isDragging: false };
    },
    methods: {
        fileName(path) {
            if (!path) return "";
            return decodeURIComponent(path).split("/").pop().split("?").pop();
        },
        isImage(path) {
            if (!path) return false;
            return /\.(jpe?g|png|gif|webp|bmp)$/i.test(path.split("?").pop());
        },
        onFileChange(e) {
            const files = Array.from(e.target.files || []);
            if (files.length) this.$emit("add", files);
            e.target.value = "";
        },
        onDrop(e) {
            this.isDragging = false;
            const files = Array.from(e.dataTransfer.files || []);
            if (files.length) this.$emit("add", files);
        }
    }
};
</script>

<style scoped>
.slip-thumb {
    position: relative;
    width: 88px;
    height: 88px;
    border-radius: 8px;
    border: 1px solid #d1d5db;
    background: #f9fafb;
    overflow: hidden;
    flex-shrink: 0;
}
.slip-thumb-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: zoom-in;
    display: block;
}
.slip-thumb-file {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 6px;
    text-align: center;
}
.slip-thumb-remove {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba(0,0,0,0.6);
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 10px;
    transition: background 0.15s;
}
.slip-thumb-remove:hover {
    background: #ef4444;
}
.slip-add {
    width: 88px;
    height: 88px;
    border: 2px dashed #d1d5db;
    border-radius: 8px;
    background: #fafafa;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: border-color 0.2s, background 0.2s;
    flex-shrink: 0;
}
.slip-add:hover {
    border-color: #3b82f6;
    background: #eff6ff;
}
.slip-add.is-loading {
    cursor: default;
    opacity: 0.75;
}
</style>
